import {
  Checkbox,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import { css } from "@/theme";

const styles = {
  filter: css`
    padding: 0 1rem;
    gap: 0.5rem;

    .MuiCheckbox-root {
      padding: 0;
      margin: 0;

      svg {
        font-size: 1rem;
      }
    }

    .MuiListItemIcon-root {
      min-width: unset;
    }

    .MuiTypography-root {
      text-transform: capitalize;
    }
  `,
};

type FilterOptionProps = {
  name: string;
  checked: boolean;
  onClick: () => void;
};

const FilterOption = ({ name, checked, onClick }: FilterOptionProps) => (
  <ListItemButton css={styles.filter} onClick={onClick}>
    <ListItemIcon>
      <Checkbox edge="start" tabIndex={-1} disableRipple checked={checked} />
    </ListItemIcon>
    <ListItemText
      primary={name}
      primaryTypographyProps={{ variant: "caption" }}
      sx={{ m: 0 }}
    />
  </ListItemButton>
);

export default FilterOption;
